<template>
  <div class="pagination-wrapper no-print">
    <button v-if="pageInfo.hasPreviousPage" @click="incrementPage(-1)" class="button previous">Previous</button>
    <span v-else></span>
    <button v-if="pageInfo.hasNextPage" @click="incrementPage(+1)" class="button next">Next</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  methods: {
    incrementPage (number) {
      this.$store.commit('events/UPDATE_PAGE', number)
      const element = document.getElementById('events-app')
      if (element) element.scrollIntoView({ behavior: 'smooth' })
    }
  },
  computed: {
    ...mapState('events', ['pageInfo'])
  }
}
</script>
